import { defineStore } from 'pinia';

import { setStorage } from "@/utils"

export const STORE_USERINFO_KEY = `STORAGE_ACCOUNT_INFO`

export const useMineStore = defineStore('mine', {
  state: () => {
    return {
		showApply: false, //判断是否显示申请列表，目前用在切换学生账号主动触发
		fromAdmin: false, //移交管理使用，判断显示审核完成的提示
		studentId: "", //移交管理员需要的学生id
		accountInfo: {} as any //当前账号的信息
    };
  },
  actions: {
   	setAccountInfo(info: any) {
			setStorage(STORE_USERINFO_KEY, info)
			this.accountInfo = info
		},
		setStudentId(id: string) {
			this.studentId = id
		},
		setFromAdmin(status: boolean) {
			this.fromAdmin = status
		},
		setApplyStatus(status: boolean) {
			this.showApply = status
		}
  },
	getters: {
		getAccountInfo(state): any {
			return state.accountInfo
		},
		getStudentId(state): string {
			return state.studentId
		},
		getFromAdmin(state): boolean {
			return state.fromAdmin
		},
		isShowApply(state): boolean {
			return state.showApply
		},
	}
});

